// Libraries
import { Injectable } from '@angular/core';
import { BaseService } from './../../../../woopa-ui/api';
import { Angular2TokenService } from 'angular2-token';

// Interfaces
import { ApiConfig } from './../../../../woopa-ui/api/config/api-config';

/**
 * `GlobalService` could get `object` or `positions` data from anywhere that implements an api RESTFUL.
 */
@Injectable()
export class GlobalSearchService extends BaseService<any> {
  /**
   * Creates a new `GlobalSearchService` instance.
   */
  constructor(
    protected tokenService: Angular2TokenService,
    protected apiConfig: ApiConfig
  ) {
    super(tokenService, 'search', apiConfig);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/layout/navbar/global-search/global-search.service.ts